/**
 * Dialog component.
 */
export function Dialog() {

  const dialogElement = 'dialog'
  const triggerIdAttr = 'data-dialog-open'
  const dialogIdAttr = 'data-dialog'
  const closeAttr = 'data-close'

  // Function to handle opening the dialog.
  const openDialog = ( event: Event ) => {
    const target = event.currentTarget as HTMLElement
    const dialogId = target.getAttribute( triggerIdAttr )
    if ( dialogId ) {
      const dialog = document.querySelector( `${dialogElement}[${dialogIdAttr}="${dialogId}"]` ) as HTMLDialogElement
      if ( dialog ) dialog.showModal()
    }
  }

  // Function to handle closing the dialog.
  const closeDialog = ( event: Event ) => {
    const target = event.currentTarget as HTMLElement
    const dialog = target.closest( dialogElement ) as HTMLDialogElement
    if ( dialog ) {
      dialog.classList.add( 'hide' )
      const handleAnimationEnd = () => {
        dialog.classList.remove( 'hide' )
        dialog.close()
        dialog.removeEventListener( 'animationend', handleAnimationEnd, false )
      }
      dialog.addEventListener( 'animationend', handleAnimationEnd, false )
    }
  }

  // Attach event listeners to buttons with attribute.
  document.querySelectorAll( `[ ${triggerIdAttr} ]` ).forEach( button => {
    button.addEventListener( 'click', openDialog )
  } )

  // Attach event listeners to buttons with data-close attribute inside dialogs.
  document.querySelectorAll( `${dialogElement} button[${closeAttr}]` ).forEach( button => {
    button.addEventListener( 'click', closeDialog )
  } )
}